import { create } from "zustand";

export type AlertVariant =
  | "success"
  | "info"
  | "warning"
  | "critical"
  | null
  | undefined;

export enum SectionType {
  attachment = "attachment",
  accessControlForm = "accessControlForm",
  comment = "comment",
  managementSettings = "managementSettings",
  directAccessControl = "directAccessControl",
  inviteUser = "inviteUser",
  resultsChartsHeader = "resultsChartsHeader",
  workflowFooter = "workflowFooter",
  userProfile = "userProfile",
  userOnboarding = "userOnboarding",
}

export type alertType = {
  variant: AlertVariant;
  message: string;
  section: SectionType;
};

interface AlerteState {
  alerts: { [key: string]: alertType | null };
  showAlert: (
    variant: AlertVariant,
    message: string,
    section: SectionType,
    id?: string,
  ) => void;
  hideAlert: (id?: string) => void;
}

export const useAlertStore = create<AlerteState>((set) => ({
  alerts: {},

  showAlert(variant, message, section, id = "default") {
    set((state) => ({
      alerts: {
        ...state.alerts,
        [id]: { variant, message, section },
      },
    }));
  },

  hideAlert: (id = "default") => {
    set((state) => {
      const newAlerts = { ...state.alerts };
      delete newAlerts[id];
      return { alerts: newAlerts };
    });
  },
}));
